import React from 'react';
import {Icon } from 'antd';
const Export = ({onClick, children}) => (
    <a href="javascript:;" onClick={onClick}><Icon type="profile" />{children}</a>
);

export default Export;